import React from "react";
import "./Spinner.scss";

const Spinner = () => {
    return <span className="spinner-border spinner-border-sm spinner" />;
};

export default Spinner;
